import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import {
  employeeActivityReportList,
  employeeProductivityReportList,
  industrialReportList,
  planningReportList,
  usersSystemReportList,
  masterChangeLogReportList,
  employeeEfficiencyReportList,
  pending_submissions_report_csv_export,
  employee_productivity_report_csv_export,
  users_system_report_csv_export,
  master_change_log_report_csv_export,
  industrial_report_csv_export,
  planning_report_csv_export,
} from "constants/reports";

export const getEmployeeActivityReportList = async (
  dispatch,
  pageNum,
  filters,
) => {
  try {
    const res = await api.pending_submissions_report(pageNum, filters);
    dispatch({ type: employeeActivityReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: employeeActivityReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getEmployeeProductivityReportList = async (
  dispatch,
  pageNum,
  filters,
) => {
  try {
    const res = await api.employee_productivity_report(pageNum, filters);
    dispatch({ type: employeeProductivityReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: employeeProductivityReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getIndustrialReportList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.industrial_report(pageNum, filters);
    dispatch({ type: industrialReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: industrialReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getPlanningReportList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.planning_report(pageNum, filters);
    dispatch({ type: planningReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: planningReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getUsersSystemReportList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.users_system_report(pageNum, filters);
    dispatch({ type: usersSystemReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: usersSystemReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getMasterChangeLogList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.master_change_log_report(pageNum, filters);
    dispatch({ type: masterChangeLogReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: masterChangeLogReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

export const getEmployeeEfficiencyReportList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.employee_efficiency_report(pageNum, filters);
    dispatch({ type: employeeEfficiencyReportList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: employeeEfficiencyReportList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

//export reports filters
export const exportEmployeeActivityReportData = async (filtersJSON) => {
  try {
    const res = await api.pending_submissions_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportEmployeeProductivityReportData = async (filtersJSON) => {
  try {
    const res = await api.employee_productivity_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportUsersSystemReportData = async (filtersJSON) => {
  try {
    const res = await api.users_system_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportMasterChangeLogReportData = async (filtersJSON) => {
  try {
    const res = await api.master_change_log_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportIndustrialReportData = async (filtersJSON) => {
  try {
    const res = await api.industrial_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportPlanningReportData = async (filtersJSON) => {
  try {
    const res = await api.planning_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportEmployeeEfficiencyReportData = async (filtersJSON) => {
  try {
    const res = await api.employee_efficiency_report_csv_export(filtersJSON);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};